/** i18n labels for gallery/camera source picker on ImageUploadButton */
export function photoSessionSourceProps(
  images: Record<string, unknown> | undefined,
) {
  const ps = (images as { photoSession?: Record<string, string> } | undefined)
    ?.photoSession;
  return {
    chooseGalleryLabel: ps?.chooseGallery,
    chooseCameraLabel: ps?.chooseCamera,
    chooseSourcePlaceholder: ps?.chooseSource,
  };
}
